module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/core.module/components/ping-test/ping-test.component.css
// module id = ./src/app/core.module/components/ping-test/ping-test.component.css
// module chunks = main